const $CompetitionIdentifier = $('.js-competition-identifier');

const $TwitterShare = $('.js-twitter-share');
const $FacebookShare = $('.js-facebook-share');

$(document).ready(() => {
  // Add AJAX click events.
  if ($CompetitionIdentifier.length > 0) {
    if ($TwitterShare.length) {
      $TwitterShare.click(() => {
        $.get('/api/analytics/LogShare', {
          shareid: 1,
          competitionIdentifier: $CompetitionIdentifier.val(),
        });
      });
    }

    if ($FacebookShare.length) {
      $FacebookShare.click(() => {
        $.get('/api/analytics/LogShare', {
          shareid: 2,
          competitionIdentifier: $CompetitionIdentifier.val(),
        });
      });
    }
  }
});

const prm = Sys.WebForms.PageRequestManager.getInstance();
prm.add_endRequest(() => {
  const $SubmitButton = $('.js-submitter');
  const $SubmittingButton = $('.js-submitting');

  if ($SubmitButton.length && $SubmittingButton.length) {
    $SubmitButton.show();
    $SubmittingButton.hide();
  }
});

prm.add_beginRequest(() => {
  const $SubmitButton = $('.js-submitter');
  const $SubmittingButton = $('.js-submitting');

  if ($SubmitButton.length && $SubmittingButton.length) {
    $SubmitButton.hide();
    $SubmittingButton.show();
  }
});
